import { DashboardChartSkeleton } from '@shigo-ui/dashboard-ui';
import { Card, CardContent } from '@shigo-ui/ui';
import { ResponsiveLineChart, type LineChartAxis, type LineChartSeries } from '@shigo-ui/viz';

import { dashboardT } from '../../../../../lib/messages';

interface PerformanceChartCardProps {
  title: string;
  axes: LineChartAxis[];
  series: LineChartSeries[];
  loading: boolean;
  error: boolean;
  controls?: React.ReactNode;
  action?: React.ReactNode;
}

export function PerformanceChartCard({
  title,
  axes,
  series,
  loading,
  error,
  controls,
  action,
}: PerformanceChartCardProps) {
  return (
    <Card className="border-border bg-card min-w-0 rounded-md shadow-[var(--shadow-xs)]">
      <div className="border-border flex min-w-0 flex-wrap items-center justify-between gap-3 border-b px-4 py-3">
        <h2 className="text-base font-semibold">{title}</h2>
        <div className="flex min-w-0 flex-wrap items-center justify-end gap-2">
          {controls}
          {action}
        </div>
      </div>
      <CardContent className="p-4">
        {loading ? (
          <DashboardChartSkeleton label={dashboardT('performanceAnalyzer.loading')} />
        ) : null}
        {!loading && error ? (
          <div className="text-destructive flex h-[340px] items-center justify-center text-sm">
            {dashboardT('performanceAnalyzer.error')}
          </div>
        ) : null}
        {!loading && !error ? (
          <ResponsiveLineChart
            ariaLabel={title}
            axes={axes}
            series={series}
            emptyMessage={dashboardT('performanceAnalyzer.empty')}
          />
        ) : null}
      </CardContent>
    </Card>
  );
}
